// Unusually Dry and Wet Conditions (UNWDC): 6-class wet/dry time series as a
// stacked bar. Takes the `unwdc_03_summary` list from `data=unwdc_03`.

import ReactECharts from "echarts-for-react";

import { UNWDC_CATEGORIES } from "./forecast";

const KEYS = UNWDC_CATEGORIES.map((c) => c.key);

const UnwdcChart = ({ data, compact = false }) => {
  if (!Array.isArray(data) || data.length === 0) return null;
  const sorted = [...data].sort((a, b) => new Date(a.date) - new Date(b.date));

  const option = {
    tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
    legend: {
      data: KEYS,
      bottom: 0,
      ...(compact
        ? { type: "scroll", textStyle: { fontSize: 10 }, itemWidth: 12, itemHeight: 10, itemGap: 6 }
        : {}),
    },
    grid: { left: "3%", right: "4%", bottom: compact ? "18%" : "10%", top: 12, containLabel: true },
    xAxis: { type: "category", data: sorted.map((r) => r.date) },
    yAxis: { type: "value", max: 100, name: compact ? "" : "% area" },
    series: UNWDC_CATEGORIES.map((cat) => ({
      name: cat.key,
      type: "bar",
      stack: "total",
      barWidth: compact ? 10 : 18,
      itemStyle: { color: cat.color },
      data: sorted.map((r) => r[cat.key] ?? 0),
    })),
  };

  return <ReactECharts option={option} style={{ height: compact ? "230px" : "300px", width: "100%" }} />;
};

export default UnwdcChart;
